var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('tab',{attrs:{"title":"我的"}}),_vm._v(" "),_c('van-cell-group',[_c('van-cell',{attrs:{"title":"修改密码","is-link":""},on:{"click":_vm.toupdPw}}),_vm._v(" "),(_vm.flg==1)?_c('van-cell',{attrs:{"title":"解除绑定","is-link":""},on:{"click":_vm.jie}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2bf22de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wode.vue
// module id = null
// module chunks = 